import styled from "styled-components";

export const StyledMap = styled.div`
  /* .temp-map {
    box-sizing: border-box;
    margin: 20px;
    display: grid;
    width: calc(100% - 40px);
    height: 500px;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    button {
      border: none;
      background-color: transparent;
      color: #333;
      font-weight: 200;
      border-bottom: 1px solid #e8e8e8;
      cursor: pointer;
      &:hover {
        background-color: #e8e8e8;
      }
      &.active {
        background-color: #ffd274;
      }
    }
  } */
  #ManagementMap {
    display: flex;
    align-items: center;
    justify-content: center;
    #container {
      width: max-content;
      height: 662px;
      display: flex;
      justify-content: center;
      position: relative;
      left: 56px;
      #allmap {
        transform: scale(0.78) translate(-73px, -120px);
        -webkit-user-drag: none; /* Safari */
        -webkit-user-select: none; /* Safari */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* IE 10+ */
        user-select: none; /* Standard syntax */
      }

      .x-center-layout-item {
        position: absolute;
      }
      .x-form-item {
        transform: translate(2px, 6px);
        .x-form-item-body > div {
          font-size: 14px;
          font-weight: 400;
        }
      }
    }
  }
`;
